import { AdOptInStatus } from 'src/hooks/useAdOptInStatus'

interface ShouldShowAdNetworkOptInBannerArgs {
  dismissed: boolean
  adOptInStatus: AdOptInStatus | null
}

export const shouldShowAdNetworkOptInBanner = ({
  dismissed,
  adOptInStatus
}: ShouldShowAdNetworkOptInBannerArgs) => {
  if (dismissed) return false
  if (!adOptInStatus) return false
  if (adOptInStatus.agreementStatus === 'active' && adOptInStatus.termsCompleted) return false

  return true
}
